module.exports = {
	model: {
		categoryID: false
	},

	events: {
		open: {
			type: 'click',
			action: function(event){
				event.stopImmediatePropagation();
				event.preventDefault();

				var self = event.data.component;
				if(self.model.categoryID) {
					self.performAndStoreAction(
						'showTagCategoryManagement_inEffect',
						self.prepareAction(
							'showTagCategoryManagement',
							undefined,
							{
								tagManagementCategoryIDs: [self.model.categoryID],
								tagManagementInEffect: true
							}
						),
						true
					);
				}
			}
		}
	},

	hooks: {
		onDecision: function($element, options){
			options = options || {};

			if(options.decisionType === 'submit' || options.decisionType === 'cancel'){
				var modal = options.decisionComponent;
				if(modal){
					this.callHandler('afterTagsUpdate');
				}
			}
		}
	}
}